// Strict phone-length rules — MUST match backend `_validate_phone_strict`.
// Do NOT modify without updating the FastAPI validator too.
//
// Dial codes are stored WITHOUT the leading "+" so they interoperate with
// react-phone-input-2 (which uses digits-only strings) and with our
// existing normalisation helpers (which also work in digits-only form).

export const EXACT_LOCAL_DIGITS = {
  "966": 9,   // 🇸🇦 Saudi Arabia
  "971": 9,   // 🇦🇪 UAE
  "965": 8,   // 🇰🇼 Kuwait
  "968": 8,   // 🇴🇲 Oman
  "974": 8,   // 🇶🇦 Qatar
};

export const COUNTRY_LABELS_AR = {
  "966": "السعودية",
  "971": "الإمارات",
  "965": "الكويت",
  "968": "عُمان",
  "974": "قطر",
};

export const COUNTRY_LABELS_EN = {
  "966": "Saudi Arabia",
  "971": "UAE",
  "965": "Kuwait",
  "968": "Oman",
  "974": "Qatar",
};

export const COUNTRY_FLAGS = {
  "966": "🇸🇦",
  "971": "🇦🇪",
  "965": "🇰🇼",
  "968": "🇴🇲",
  "974": "🇶🇦",
};

// Other dial codes accepted app-wide (no exact-length rule; general 6–15).
export const OTHER_DIALS = [
  "973", "967", "962", "963", "964", "961", "970",
  "20", "218", "212", "213", "216", "249",
  "90", "92", "91", "62", "60", "880",
  "44", "1", "33", "49", "34", "39",
];
